<template>
  <div>
    <el-form ref="formRef" :model="editorForm" label-width="88px">
      <el-form-item label="头像：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
      <el-form-item label="昵称：">
        <el-input v-model="editorForm.nickName" placeholder="请输入昵称" style="width:16em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData } from "@/api/api"
import { updateOfficialInfo } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      editorForm: this.value.editorForm,
      files: null,
      src: this.value.editorForm.avatar?this.value.editorForm.avatar:'',
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.editorForm.nickName) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '昵称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '头像不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      param.append('id', this.editorForm.id);
      param.append('nickName', this.editorForm.nickName);
      param.append('file', this.files);
      imgPostFormData(updateOfficialInfo, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
